import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { StatusBadgeComponent } from 'src/app/components/library/status-badge/status-badge.component';
import { FormPopupComponent } from 'src/app/components/utils/form-popup/form-popup.component';
import { IFooterButton } from 'src/app/types/footerButtons';

/** Display-only payload prepared by the parent. */
export interface IRequiredActionInfoDialogData {
    title: string;
    status: string;
    statusLabel: string;
    statusTooltipKey?: string | null;
    reason: string;
    createdAt: string;
    createdBy: string;
    description: string;
}

@Component({
    selector: 'app-required-action-info-dialog',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TranslocoPipe, FormPopupComponent, StatusBadgeComponent],
    templateUrl: './required-action-info-dialog.component.html',
    styleUrl: './required-action-info-dialog.component.scss',
})
export class RequiredActionInfoDialogComponent {
    visible = input(false);
    data = input<IRequiredActionInfoDialogData | null>(null);
    footerButtons = input<IFooterButton[]>([]);
    titleIconClass = input('cn-icon-ico-alarm');

    visibleChange = output<boolean>();
    clicked = output<string>();

    onVisibleChange(visible: boolean): void {
        this.visibleChange.emit(visible);
    }

    onFooterClicked(action: string): void {
        this.clicked.emit(action);
    }
}
